export const dateFormatter = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  timeZone: 'Europe/Berlin',
})

export const toLocalDate = (date: Date | null): Date => {
  if (!date) {
    return new Date()
  }

  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export function compareDates(date1: string, date2: string): number {
  const d1 = new Date(date1)
  const d2 = new Date(date2)

  d1.setHours(0, 0, 0, 0)
  d2.setHours(0, 0, 0, 0)

  return d1.getTime() - d2.getTime()
}

export function formatDate(date?: string | Date | null): string | null {
  if (!date) {
    return null
  }

  const d = typeof date === 'string' ? new Date(date) : date

  return dateFormatter.format(d)
}
